/**
 * 数科-金融-提现结果页-营销位 - 通过广告投放系统接入 https://fat-admaster.hellobike.cn/#/ssp/operation-mng
 * 广告位信息
 * 名称: 数科-金融-提现结果页首页-召回营销位
 * uuid: 3cdab29b8fab4410ae9ee57654a6750f
 */
import { Vue, Component } from 'vue-property-decorator';
import { dialogHelper } from '@/shared/utils/dialogHelper';
import AdvCommonContainer from '../adv-common-container';

@Component
export default class AdvApplyFailPopup extends Vue {
  private onLoadHandler() {
    /** 已展示了弹窗，同步状态到弹窗管理 */
    dialogHelper.applyOpenDialog(true);
  }

  private onCancelHandler() {
    /** 已关闭弹窗，同步状态到弹窗管理 */
    dialogHelper.closeDialogNotify();
  }

  private onConfirmHandler() {
    /** 已关闭弹窗，同步状态到弹窗管理 */
    dialogHelper.closeDialogNotify();
  }

  private render() {
    return (
      <AdvCommonContainer
        advMasterId="3cdab29b8fab4410ae9ee57654a6750f"
        customVisibility="true"
        onLoad={() => this.onLoadHandler()}
        onCancel={() => this.onCancelHandler()}
        onConfirm={() => this.onConfirmHandler()}
      />
    );
  }
}
